<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import Button from '@uiKit/elements/Button.vue'
import PiIcon from '@uiKit/elements/PiIcon.vue'

// The "Need a hand?" strip closing every state of the request-detail screen,
// and of the property detail screen, which passes its own line. The container
// decides who answers — today the seller's relationship manager.
withDefaults(defineProps<{ message?: string }>(), {
  message: 'Our team can help with documents, pricing or the review process.',
})

const emit = defineEmits<{ support: [] }>()
</script>

<template>
  <Box is="aside" flex align="center" gap="3" class="help">
    <PiIcon name="question-circle" class="help__icon" />
    <Box direction="col" gap="0.125rem" grow class="help__text">
      <Text is="span" type="body" weight="semibold" color="default">Need a hand?</Text>
      <Text is="span" type="caption">{{ message }}</Text>
    </Box>
    <Button
      label="Contact support"
      variant="outline"
      color="secondary"
      size="small"
      @click="emit('support')"
    />
  </Box>
</template>

<style scoped>
.help {
  padding: 1rem 1.25rem;
  border: 1px solid var(--p-primary-200);
  border-radius: 12px;
  background: var(--p-primary-50);
  flex-wrap: wrap;
  row-gap: 0.75rem;
}

.help__icon {
  flex-shrink: 0;
  font-size: 1.125rem;
  color: var(--p-primary-600);
}

.help__text {
  min-width: 12rem;
}
</style>
